module.exports = "<p>\n  role-form works!\n</p>\n"